import React from 'react';
import { CardNumberElement, injectStripe, CardExpiryElement, CardCvcElement } from 'react-stripe-elements';
import Button from '../../components/UI/Button/Button';
import formStyles from './Form.css';
import { createStripeOptions } from './stripeOptions';

const CreditCardFormComponent = props => {
    const onPayClicked = async () => {
        props.pay(props.stripe, props.elements.getElement('cardNumber'));
    }
    return (
        <div>
            <p className={formStyles.Title}>{props.translations.label_info_payment}</p>
            {/* <p className={formStyles.Description}>{props.translations.label_info_payment.replace('{0}', props.paymentRequiredAmount)}</p> */}
            <div className={formStyles.CardElementContainer}>
                <CardNumberElement 
                    className={[formStyles.StripeElement, formStyles.StripeElementCardNumber].join(' ')}
                    {...createStripeOptions()}
                />
                <CardExpiryElement 
                    className={[formStyles.StripeElement, formStyles.StripeElementMonth].join(' ')}
                    {...createStripeOptions()}
                />
                <CardCvcElement 
                    className={[formStyles.StripeElement, formStyles.StripeElementCvc].join(' ')}
                    {...createStripeOptions()}
                />
            </div>
            <p className={formStyles.ErrorText}>{props.errorText}</p>
            <div className={formStyles.PayButtonContainer}>
                <Button
                    btnLabel={props.translations.label_pay_and_confirm}
                    clicked={onPayClicked}
                    disabledButton={props.isSubmittingCard}
                />
            </div>
        </div>
    )
}

export const CreditCardForm = injectStripe(CreditCardFormComponent);


// WEBPACK FOOTER //
// ./src/containers/BookingFlow/CreditCardForm.js